module.exports = __webpack_public_path__ + "img/Wp_2022.c8b8631a.png";